import { connect } from 'react-redux';
import { AppState } from '../../redux/store';
import {
  selectPostTourSurveyQuestions,
  selectSurveyRequestStatus,
  selectSurveyUpdateStatus,
} from '../../redux/selectors/survey';
import {
  surveyPostTourQuestionsRequest,
  updatePostTourSurveyQuestions
} from '../../redux/actions/survey';
import { SurveyPostTourQuestions } from './SurveyPostTourQuestions';
import { getBuilderId } from "../../redux/selectors/auth";

const mapStateToProps = (state: AppState) => ({
  surveyQuestions: selectPostTourSurveyQuestions(state),
  loading: selectSurveyRequestStatus(state),
  updating: selectSurveyUpdateStatus(state),
  builderId: getBuilderId(state),
});

const mapDispatchToProps = {
  updateQuestions: updatePostTourSurveyQuestions,
  loadSurveyQuestions: surveyPostTourQuestionsRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SurveyPostTourQuestions);
